import React, { Component } from 'react'
import styled from 'styled-components'
import SVG  from 'react-inlinesvg';

const PROFILE_WIDTH = 300


const Container = styled.div`
	display: flex;
	background-color: white;
	height: 100vh;
	width: 100vw;
	overflow: hidden;
`
const BodyContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
	box-sizing: border-box;
	box-shadow: -5px 0 30px 0px rgba(0,0,0,0.7);
	overflow-y: auto;
`
const WorkContainer = styled.div`
	width: 100%;
	max-width: 800px;
	box-sizing: border-box;
`
const ProfileContainer = styled.div`
	background-color: #313747;
	// height: 100vh;
	width: ${PROFILE_WIDTH}px;
	padding: 15px;
	box-sizing: border-box;
	overflow-y: auto;
`
const ProfilePhoto = styled.img`
	height: 150px;
	width: 150px;
	border-radius: 75px;
	box-shadow: 0 3px 20px 3px rgba(0,0,0,0.4);
	margin-bottom: 30px;

	@media (max-width: 1000px) {
		height: 100px;
		width: 100px;
		border-radius: 50px;
		margin-bottom: 15px;
  }
`



const Text = styled.p`
	font-size: 16px;
	line-height: 24px;
	opacity: 1;
	max-width: 800px;
	color: #313747;

	@media (max-width: 1000px) {
		font-size: 14px;
	}
`
const JustifiedText = Text.extend`
	text-align: justify;
`
const LightText = Text.extend`
	color: #CCD9FC;
`
const GreenText = Text.extend`
	color: #19b7b4;
`
const TitleText = Text.extend`
	font-size: ${props => props.size === 'small' ? 30 : 40}px;
	font-weight: 700;
	line-height: 50px;
	text-align: center;
	padding-bottom: 5px;
	color: #4C5775;

	@media (max-width: 1000px) {
		font-size: ${props => props.size === 'small' ? 20 : 40}px;
  }
`
const LightTitleText = TitleText.extend`
	color: #CCD9FC;

`
const TitleUnderline = styled.div`
	width: 0; 
  height: 0; 
	padding-bottom: 35px;
  margin: 5px auto 0 auto;
  border-left: 23vw solid transparent;
  border-right: 23vw solid transparent;
  border-top: 5px solid #4C5775;
`
const SmallTitleUnderline = TitleUnderline.extend`
  border-left: 130px solid transparent;
  border-right: 130px solid transparent;
  border-top: 3px solid #19b7b4;

  @media (max-width: 1000px) {
		border-left: 100px solid transparent;
		border-right: 100px solid transparent;
	}
`
const CenteredContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const SkillsContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
`
const SkillBubble = styled.div`
	flex-grow: 1;
	background-color: rgba(0,0,0,0.3);
	border-radius: 10px;
	padding: 5px 15px 5px 15px;
	margin: 5px 2px 5px 2px;
	color: #4C5775 !important;
	text-align: center;
`

const Link = styled.a`
	color: #CCD9FC !important;
`



export default class Resume extends Component {


	render() {

		return (
			<Container>
        {this.Profile()}
				{this.Body()}
      </Container>
		)
	}


	Profile() {

		return (
			<ProfileContainer>
				<CenteredContent>
					<ProfilePhoto src={require('../img/profile-photo.jpg')} />
					<LightTitleText size='small'>David Richard</LightTitleText>
					<LightText style={{opacity: 0.7, marginTop: -10}}>Web & Mobile Developer</LightText>
					<SmallTitleUnderline />
					<LightText>128 Mariners Dr.</LightText>
					<LightText style={{paddingBottom: 35}}>Ormond Beach, FL 32176</LightText>
				</CenteredContent>

				<LightText style={{paddingBottom: 10}}>
					<SVG className='small-icon' src={require("../img/email.svg")} />
					david@davidrichard.xyz
				</LightText>
				<LightText style={{paddingBottom: 10}}>
					<SVG className='small-icon' src={require("../img/phone.svg")} />
					386.868.6629
				</LightText>
				<LightText style={{paddingBottom: 10}}>
					<SVG className='small-icon' src={require("../img/website.svg")} />
					<Link href='http://davidrichard.xyz' target='_blank'>davidrichard.xyz</Link>
				</LightText>
				<LightText style={{paddingBottom: 10}}>
					<SVG className='small-icon github' src={require("../img/github.svg")} />
					<Link href='http://github.com/davidrichard23' target='_blank'>github.com/davidrichard23</Link>
				</LightText>

				<LightTitleText style={{paddingTop: 20}} size='small'>Skills</LightTitleText>
				<SmallTitleUnderline />

				<SkillsContainer>
					<SkillBubble><GreenText>Javascript</GreenText></SkillBubble>
					<SkillBubble><GreenText>HTML/CSS</GreenText></SkillBubble>
					<SkillBubble><GreenText>React</GreenText></SkillBubble>
					<SkillBubble><GreenText>React Native</GreenText></SkillBubble>
					<SkillBubble><GreenText>Redux</GreenText></SkillBubble>
					<SkillBubble><GreenText>ES6</GreenText></SkillBubble>
					<SkillBubble><GreenText>NodeJS</GreenText></SkillBubble>
					<SkillBubble><GreenText>Parse Server</GreenText></SkillBubble>
					<SkillBubble><GreenText>Unity</GreenText></SkillBubble>
					<SkillBubble><GreenText>C#</GreenText></SkillBubble>
					<SkillBubble><GreenText>Lua</GreenText></SkillBubble>
					<SkillBubble><GreenText>Photoshop</GreenText></SkillBubble>
					<SkillBubble><GreenText>Fusion 360 (CAD)</GreenText></SkillBubble>
					<SkillBubble><GreenText>Blockchain Basics</GreenText></SkillBubble>
				</SkillsContainer>
			</ProfileContainer>
		)
	}


	Body() {

		return (
			<BodyContainer>
				<TitleText>Intro</TitleText>
				<TitleUnderline />
				<JustifiedText>Highly motivated self taught web and mobile developer with a passion for creating intuitive and unique user experiences. Seeking an opportunity to contribute using my current skill set while also expanding my knowledge by working along side a brilliant group of people.</JustifiedText>
				<TitleText style={{paddingTop: 50}}>Work History</TitleText>
				<TitleUnderline />
				<WorkContainer>
					<JustifiedText style={{fontWeight: '700'}}>March 2017 to Present</JustifiedText>
					<Text style={{fontWeight: '700', color: '#19b7b4', paddingBottom: 10}}>Web & Mobile Developer - Freelancer</Text>
					{this.BulletPoint(`Developed a platform for Cornell medical students which allows physicians to communicate with, and track the progress of their patient's injuries and surgical incisions privately and securely using pictures. Currently in private beta being used by Surgeons at NewYork-Presbyterian/Weill Cornell Medical Center.`)}
					{this.BulletPoint(`Developed a contest based app which contestants can submit photos and voters can vote on their favorite. The job also included an admin website where the owners can perform administrative tasks including creating new contests, approving photos, and handle disqualifications among other features. Currently the app is in private beta while the initial contests are being filled by contestants.`)}

					<JustifiedText style={{fontWeight: '700', paddingTop: 10}}>February 2015 to March 2017</JustifiedText>
					<Text style={{fontWeight: '700', color: '#19b7b4', paddingBottom: 10}}>Web & Mobile Developer - DineSafe</Text>
					{this.BulletPoint(`Designed and developed a platform for restaurants to manage and provide allergen and nutritional information to their customers. The customer facing app sorts a restaurant's menu items based on the their restrictions.`)}
					{this.BulletPoint(`Had the responsibilities of restaurant, user, and press outreach.`)}
					{this.BulletPoint(`Served a role in fostering a partnership with an international restaurant franchise.`)}

					<JustifiedText style={{fontWeight: '700', paddingTop: 10}}>March 2012 to February 2015</JustifiedText>
					<Text style={{fontWeight: '700', color: '#19b7b4', paddingBottom: 10}}>Owner/Operator - iCustoms</Text>
					{this.BulletPoint(`Fixed and customized thousands of smartphones.`)}
					{this.BulletPoint(`Sourced trending smartphone cases and accesories from overseas.`)}
					{this.BulletPoint(`Taught myself to code during my downtime.`)}

					<JustifiedText style={{fontWeight: '700', paddingTop: 10}}>May 2008 to December 2011</JustifiedText>
					<Text style={{fontWeight: '700', color: '#19b7b4', paddingBottom: 10}}>Food-Runner - Silver Gulch</Text>
					{this.BulletPoint(`Made sure that all orders were correctly prepared.`)}
					{this.BulletPoint(`Ran food to tables.`)}

					<TitleText style={{paddingTop: 50}}>Other Achievements</TitleText>
					<TitleUnderline />
					{this.BulletPoint(`Created a bot that leverages the API of a hashing power renting site and a Bitcoin mining pool. The bot has profited over 7.75 Bitcoins over a 3 month period.`)}
					{this.BulletPoint(`Currently negotiating a licensing deal with a company who's interested in an invention I have a patent pending on.`)}
				</WorkContainer>
			</BodyContainer>
		)
	}


	BulletPoint(text) {

		return (
			<div style={{display: 'flex', paddingBottom: 5}}>
				<SVG className='bullet-point-icon' src={require("../img/bullet-arrow.svg")} />
				<JustifiedText>{text}</JustifiedText>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Resume.js